import React from 'react';
import CompanySearch from './CompanySearch'
import {
    useHistory
  } from "react-router-dom";
  
  function Home()  {

    
    const data = [
      {
      "id": 1,
      "name": "Favorite BBQ",
      "street": "123 Main St.",
      "city": "Sandy Springs",
      "state": "Georgia"
    },
    {
      "id": 2,
      "name": "Favorite Pizza",
      "street": "123 A Blvd.",
      "city": "Sandy Springs",
      "state": "Georgia"
    },
    {
      "id": 3,
      "name": "Favorite Dry Cleaners",
      "street": "456 Main St.",
      "city": "Sandy Springs",
      "state": "Georgia"
    }
    ];

    return <div className="App container">
            <div class="row">
                <div class="col-12">Here are the companies found:</div>
            </div>
            <div className="containr">
              <BusinessList data={data} />
            </div>
        </div>
    ;
  }

  function BusinessList(props) {

    const data = props.data;

    let history = useHistory();

    function onSubmit(id)
    {
      history.push("/company/"+id);
    }
  
      return data.map((node, index) => {

        const id = node.id;

        return <div className="row">
          <div className="col-4">{node.name}</div>
          <div className="col-3">{node.street}</div>
          <div className="col d-none d-sm-block">{node.city}</div>
          <div className="col d-none d-sm-block">{node.state}</div>
          <div className="col-1"><input type="image" src="/go-button.png" onClick={() => onSubmit(id)}/></div>
        </div>
      })
    
  }
 
  export default Home;


